export default {
  /**
   * @todo REFACTOR ROUTER
   * Prove if we can move it to the `src/modules/Configurator/routes/*.js` itself
   */
  beforeRouteLeave(_to, _from, next) {
    this.transition = 'slide-up'
    this.$nextTick(next())
  },

  methods: {
    enter(element) {
      const width = getComputedStyle(element).width

      element.style.width = width
      element.style.position = 'absolute'
      element.style.visibility = 'hidden'
      element.style.height = 'auto'

      const height = getComputedStyle(element).height

      element.style.width = null
      element.style.position = null
      element.style.visibility = null
      element.style.height = 0

      setTimeout(() => {
        element.style.height = height
      })
    },

    afterEnter(element) {
      element.style.height = 'auto'
    },

    leave(element) {
      const height = getComputedStyle(element).height

      element.style.height = height

      setTimeout(() => {
        element.style.height = 0
      })
    },
  },
}
